// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const CartSource = {
  Web: {
    Name: 'Web',
    Value: 'web',
  },
  POS: {
    Name: 'POS',
    Value: 'pos',
  },
} as const

export type CartSourceValue = (typeof CartSource)[keyof typeof CartSource]['Value']
